// Google Consent Mode v2 helpers. The default state (denied) is set by an inline
// snippet in index.html BEFORE GTM loads, so no ad/analytics storage happens
// until the visitor opts in. This module persists + updates that choice.

const KEY = 'zenzers-consent'

export type ConsentChoice = 'accepted' | 'rejected'

export function getStoredConsent(): ConsentChoice | null {
  try {
    const v = localStorage.getItem(KEY)
    return v === 'accepted' || v === 'rejected' ? v : null
  } catch {
    return null
  }
}

export function storeConsent(choice: ConsentChoice): void {
  try {
    localStorage.setItem(KEY, choice)
  } catch {
    /* storage unavailable — ignore */
  }
}

/** Flip Consent Mode v2 signals for ad + analytics storage. */
export function updateConsent(granted: boolean): void {
  if (typeof window === 'undefined') return
  const w = window as unknown as { dataLayer: unknown[] }
  w.dataLayer = w.dataLayer || []
  const value = granted ? 'granted' : 'denied'
  // gtag() pushes the literal `arguments` object onto dataLayer (GTM contract).
  w.dataLayer.push(['consent', 'update', {
    ad_storage: value,
    ad_user_data: value,
    ad_personalization: value,
    analytics_storage: value,
  }])
}
